

<p *ngIf="title"  class="text-info-sm text-upper-case">
 <nz-badge [nzColor]="badgeColorHex" class="" *ngIf="showBadge"></nz-badge>
  {{ title}}
</p>
<p class="text-info-bold-xs opacity-70 mb-xxs" *ngIf="subtitle">{{ subtitle }}</p>
<div class="macronutrients macros-in-select d-flex
          justify-content-between">
  <div *ngIf="calories !== undefined" class="macronutrient d-flex flex-column justify-content-center
            align-items-center">
    <img loading="lazy" class="img-macro"
         src="./assets/images/icons/icons8-chocolatina-100.png" [width]="maxImageWidth" height="auto" alt="">
    <p class="text-info-bold-xs">Calorías</p>
    <p class="text-info text-bold text-small">{{
      +((calories).toFixed(2)) ?? 0
      }} kcal</p>
  </div>
  <div *ngIf="lipids !== undefined" class="macronutrient d-flex flex-column justify-content-center
            align-items-center">
    <img loading="lazy" class="img-macro"
         src="./assets/images/icons/icons8-sunny-side-up-huevos-100.png"
         [width]="maxImageWidth" height="auto"
         alt="">
    <p class="text-info-bold-xs">Grasas</p>
    <p class="text-info text-bold text-small">{{
      +((lipids).toFixed(2)) ?? 0
      }} g</p>
  </div>
  <div *ngIf="carbohydrates !== undefined" class="macronutrient d-flex flex-column justify-content-center
            align-items-center">
    <img loading="lazy" class="img-macro"
         src="./assets/images/icons/icons8-pastel-de-nata-100.png"
         [width]="maxImageWidth" height="auto"
         alt="">
    <p class="text-info-bold-xs">H.C</p>
    <p class="text-info text-bold text-small">{{
      +((carbohydrates).toFixed(2)) ??
      0 }} g</p>
  </div>
  <div *ngIf="proteins !== undefined" class="macronutrient d-flex flex-column justify-content-center
            align-items-center">
    <img loading="lazy" class="img-macro"
         src="./assets/images/icons/icons8-jamon-100.png"
         [width]="maxImageWidth" height="auto"
         alt="">
    <p class="text-info-bold-xs">Proteínas</p>
    <p class="text-info text-bold text-small">{{
      +((proteins).toFixed(2)) ?? 0 }}
      g</p>
  </div>
  <div *ngIf="fiber !== undefined" class="macronutrient d-flex flex-column justify-content-center
            align-items-center">
    <img loading="lazy" class="img-macro"
         [width]="maxImageWidth" height="auto"
         src="./assets/images/icons/icons8-heno-100.png" alt="">
    <p class="text-info-bold-xs">Fibra</p>
    <p class="text-info text-bold text-small">{{
      +((fiber).toFixed(2)) ??
      0 }} g</p>
  </div>
</div>

<div class="d-flex justify-content-end mt-xs" *ngIf="this.numberBlocks > 0">
  <p class="text-info-bold-xs opacity-70">{{ this.numberBlocks }} {{'tiempo' + (this.numberBlocks > 1 ? 's' : '') + ' de comida.'}}</p>
</div>
